module.exports = __webpack_public_path__ + "img/danye5.892cf266.jpg";